import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.PERSON_DETAILS_CREATE}`,
            render: () => import("../../Pages/Core/PersonsServed/AddNewPerson/AddNewPerson.svelte"),
            title: "Add New Person"
        }
    ]
};

export default routerConfig;